import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/coins-02.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M21 9.01221C21 5.6985 18.3137 3.01221 15 3.01221C12.3847 3.01221 10.16 4.68637 9.33887 7.021C13.4872 7.1939 16.8168 10.5242 16.9902 14.6724C19.3251 13.8514 21 11.6277 21 9.01221ZM8.44531 11.1802C8.7521 10.9756 9.14656 10.9565 9.47168 11.1304C9.79684 11.3044 10 11.6434 10 12.0122V16.5122H10.5C11.0523 16.5122 11.5 16.9599 11.5 17.5122C11.5 18.0645 11.0523 18.5122 10.5 18.5122H7.5C6.94772 18.5122 6.5 18.0645 6.5 17.5122C6.5 16.9599 6.94772 16.5122 7.5 16.5122H8V13.8765C7.54692 14.1392 6.96249 14.0087 6.66797 13.5669C6.36162 13.1074 6.48578 12.4865 6.94531 12.1802L8.44531 11.1802ZM3 15.0122C3 18.3259 5.68629 21.0122 9 21.0122C12.3137 21.0122 15 18.3259 15 15.0122C15 11.6985 12.3137 9.01221 9 9.01221C5.68629 9.01221 3 11.6985 3 15.0122ZM23 9.01221C23 12.814 20.3487 15.9942 16.7939 16.8091C15.9782 20.3618 12.8002 23.0122 9 23.0122C4.58172 23.0122 1 19.4305 1 15.0122C1 11.2123 3.64984 8.03327 7.20215 7.21729C8.01727 3.66294 11.1985 1.01221 15 1.01221C19.4183 1.01221 23 4.59393 23 9.01221Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as Coins02Icon };
